// src/components/OAuthStatus.jsx
import React from 'react';
import { useSearchParams } from 'react-router-dom';

const OAuthStatus = () => {
  const [searchParams] = useSearchParams();
  
  const provider = searchParams.get('params');
  const email = searchParams.get('email');
  const ok = searchParams.get('ok');
  const error = searchParams.get('error');

  // Check if it's a Gmail OAuth callback
  if (provider === 'gmail') {
    if (ok === '1' && email) {
      // Success case
      return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Congratulations!
            </h1>
            <p className="text-gray-600 mb-2">
              Your Gmail OAuth is completed successfully with email address:
            </p>
            <p className="text-lg font-semibold text-blue-600 mb-6">
              {email}
            </p>
            <button 
              onClick={() => window.close()}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-4 rounded-lg transition duration-200"
            >
              Close Window
            </button>
          </div>
        </div>
      );
    } else if (error === 'oauth_failed') {
      // Failure case
      return (
        <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Connection Failed
            </h1>
            <p className="text-gray-600 mb-6">
              OAuth connection failed. Please try again.
            </p>
            <div className="space-y-3">
              <button 
                onClick={() => window.location.reload()}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition duration-200"
              >
                Try Again
              </button>
              <button 
                onClick={() => window.close()}
                className="w-full bg-gray-500 hover:bg-gray-600 text-white font-medium py-3 px-4 rounded-lg transition duration-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    }
  }

  // Default case - no valid parameters
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-4">
          Invalid Request
        </h1>
        <p className="text-gray-600 mb-6">
          This page is for OAuth callbacks. No valid OAuth parameters found.
        </p>
        <button 
          onClick={() => window.close()}
          className="w-full bg-gray-600 hover:bg-gray-700 text-white font-medium py-3 px-4 rounded-lg transition duration-200"
        >
          Close Window
        </button>
      </div>
    </div>
  );
};

export default OAuthStatus;